export default {
  width: {
    NAV_DRAWER: 240,
  },
  height: {
    NAV_HEADER: 60,
  },
  deliveryType: {
    takeaway: '外賣',
    storeDelivery: '外送',
  },
  // 收單通道 (payment.gateway) 的顯示名稱，未列出的通道維持顯示內部識別值
  paymentGatewayName: {
    wonderPay: 'Wonder Pay',
    qfpayOffline: 'QFPay',
  },
}
